import { LevelObject } from "shared/levels";
import { Block } from "shared/model";
import { DefaultConfig } from "shared/config";
import { Main } from "screens/main";
import { LoaderService } from "shared/services";

export class TilesHelper {
    public static deleteTiles(container): void {
        for (let i = 0; i < LevelObject.columns; i++) {
            let shift = 0;
            for (let j = LevelObject.rows - 1; j >= 0; j--) {
                const tile = LevelObject.tiles[i][j];
                if (tile && tile.type === -1) {
                    shift += 1;
                    LevelObject.tiles[i].splice(j, 1);
                    container.removeChild(tile)
                }
            }
        }

        // this.createForMix(container);
    }

    public static getNewTexture(levelChances) {
        const num = this.getTileTexture(levelChances);
        let texture = {
            type: 0,
            texture: null,
            color: '',
        };
        
        switch (num) {
            case 0: {
                texture.texture = LoaderService.getSpritesheet('main_sprites').textures['Tile_1.png'];
                texture.type = 1;
                break;
            }
            case 1: {
                texture.texture = LoaderService.getSpritesheet('main_sprites').textures['Tile_2.png'];
                texture.type = 2;
                break;
            }
            case 2: {
                texture.texture = LoaderService.getSpritesheet('main_sprites').textures['Tile_3.png'];
                texture.type = 3;
                break;
            }
            case 3: {
                texture.texture = LoaderService.getSpritesheet('main_sprites').textures['Tile_4.png'];
                texture.type = 4;
                break;
            }
            case 4: {
                texture.texture = LoaderService.getSpritesheet('main_sprites').textures['Tile_5.png'];
                texture.type = 5;
                break;
            }
        }
        return texture;
    }

    public static clearPoolFromDeletedTiles(): void {
        const tiles = LevelObject.tiles;

        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                for (let d = 0; d < tiles[i][j].length; d++) {
                    
                }
            }
        }
    }

    public static getTileTexture(levelChance) {
        let num = 0;
        let texture;
        const array = [];
        for (let key in levelChance) {
            if (array[num - 1]) {
                array.push({from: array[num - 1].to + 1, to: array[num - 1].to + levelChance[key]})
            } else {
                array.push({from: 0, to: levelChance[key]})
            }

            num += 1;
        }
        const rand = Math.floor(Math.random() * 100);
        for (let i = 0; i < array.length; i++) {
            if (rand >= array[i].from && rand <= array[i].to) {
                texture = i;
            }
        }
        return texture
    }

    public static createTile(i, j, isHasProduct: boolean = false): Block {
        const colors = DefaultConfig.colors;
        const color = colors[Math.floor(Math.random() * colors.length)];
        let sprite: Block;
        switch (color) {
            case 'red': {
                sprite = new Block(Main.instance.app.loader.resources.red.texture);
                sprite.color = 'red';
                sprite.type = 1;
                break;
            }
            case 'green': {
                sprite = new Block(Main.instance.app.loader.resources.pink.texture);
                sprite.color = 'green';
                sprite.type = 2;
                break;
            }
            case 'blue': {
                sprite = new Block(Main.instance.app.loader.resources.dark_purp.texture);
                sprite.color = 'blue';
                sprite.type = 3;
                break;
            }
            case 'brown': {
                sprite = new Block(Main.instance.app.loader.resources.purp.texture);
                sprite.color = 'brown';
                sprite.type = 4;
                break;
            }
            case 'yellow': {
                sprite = new Block(Main.instance.app.loader.resources.tile_5.texture);
                sprite.color = 'yellow';
                sprite.type = 5;
                break;
            }
        }

        const graphic = new PIXI.Graphics();
        graphic.beginFill();
        graphic.drawRect(0, 0, LevelObject.tileWidth, LevelObject.tileHeight);
        graphic.endFill();
        graphic.alpha = 0;
        const coord = this.getCoordinateTile(i, j);
        sprite.width = LevelObject.tileWidth - LevelObject.tilesMargin;
        sprite.height = LevelObject.tileHeight - LevelObject.tilesMargin;
        sprite.x = coord.tileX;
        sprite.y = coord.tileY;
        sprite.row = j;
        sprite.col = i;
        // sprite.stateMachine = new BlockStateMashine(sprite);
        sprite.shift = 0;

        if (isHasProduct) {
            sprite.type = 0;
        }

        if (isHasProduct && j !== 0) {
            sprite.alpha = 0;
        }

        if (isHasProduct && j === 0) {
            const productSprite = new PIXI.Sprite(Main.instance.app.loader.resources.drop_product1.texture);
            productSprite.width = sprite.width - LevelObject.tilesMargin / 2;
            productSprite.height = sprite.height * 3;
            sprite.addChild(productSprite);
            sprite.alpha = 1;
        }

        sprite.addChild(graphic);

        return sprite
    }

    public static getCoordinateTile(column, row) {
        var tileX = column * (LevelObject.tileWidth);
        var tileY = row * (LevelObject.tileHeight);
        // var tileX = LevelObject.x + column  * LevelObject.tileWidth;
        // var tileY = LevelObject.y + row * LevelObject.tileHeight;
        return { tileX: tileX, tileY: tileY };
    }
}